$(function() {

	// page-accordion
	// wandelt innerhalb von .page-accordion alle h2 und h3 in klickbare Elemente um,
	// versteckt deren hierarchisch untergeordnete Elemente
	// und zeigt/versteckt diese je nach Klick auf die Überschrift
	$('.page-accordion').each(function(){

		var self = $(this),
			accordionHeadlineClass = 'page-accordion-headline',
			accordionHeadlineActiveClass = 'page-accordion-headline-active',
			accordionBlockClass = 'page-accordion-block',
			accordionBlockActiveClass = 'page-accordion-block-active',
			accordionLevelClassSegment = '-level-';

		function wrapNextFromHeadline (container, elementSelector, levelStr) {
			container.find(elementSelector)
				.addClass(accordionHeadlineClass)
				.addClass(accordionHeadlineClass + accordionLevelClassSegment + levelStr)
				.each(function(){
					var headline = $(this),
						next = headline.nextUntil(elementSelector);
					next.wrapAll('<div class="' + accordionBlockClass + ' ' + accordionBlockClass + accordionLevelClassSegment + levelStr + '"></div>');
				});
		}

		wrapNextFromHeadline(self, 'h2', '1');
		wrapNextFromHeadline(self, 'h3', '2');

		// $('.' + accordionBlockClass).hide();

		self.find('.' + accordionHeadlineClass).on('click', function(e){
			e.preventDefault();
			var self = $(this);
			self.toggleClass(accordionHeadlineActiveClass)
				.next('.' + accordionBlockClass)
				.toggleClass(accordionBlockActiveClass);
		});

	});

});